let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3Z1bu")).then(() => parcelRequire('1TBFj'));